import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { thickV2NfpPositionMintAbi } from "@/domains/abis/thick-v2-nfpm-abi"
import type { TokenAddress } from "@/domains/core"
import type { TransactionReceiptWaitOptions, TransactionReturnType } from "@/domains/on-chain"
import { simulatedTransaction } from "@/domains/on-chain/simulated-transaction"

type CreateThickV2NfpPositionProps = {
  account: Address
  chainId: number
  config: Config
  token0: TokenAddress
  token1: TokenAddress
  tickSpacing: number
  tickLower: bigint
  tickUpper: bigint
  amount0Desired: bigint
  amount1Desired: bigint
  amount0Min: bigint
  amount1Min: bigint
  deadline: number
  nfpManagerAddress: Address
  receiptWait?: TransactionReceiptWaitOptions
}

export const createThickV2NfpPositionPool = async ({
  account,
  chainId,
  config,
  token0,
  token1,
  tickSpacing,
  tickLower,
  tickUpper,
  amount0Desired,
  amount1Desired,
  amount0Min,
  amount1Min,
  deadline,
  nfpManagerAddress,
  receiptWait,
}: CreateThickV2NfpPositionProps): Promise<TransactionReturnType> => {
  try {
    const params = {
      token0: token0.address,
      token1: token1.address,
      tickSpacing,
      tickLower,
      tickUpper,
      amount0Desired,
      amount1Desired,
      amount0Min,
      amount1Min,
      recipient: account,
      deadline,
    }

    return await simulatedTransaction({
      config,
      simulateArgs: {
        abi: thickV2NfpPositionMintAbi as Abi,
        account,
        address: nfpManagerAddress,
        args: [params],
        chainId,
        functionName: "mint",
      },
      receiptWait,
    })
  } catch (error: unknown) {
    console.error("createThickV2NfpPositionPool", error)
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
      code: error instanceof Error && "code" in error ? Number((error as { code: string }).code) : 0,
    }
  }
}
